import { render, staticRenderFns } from "./YAH.vue?vue&type=template&id=1777ae8e&scoped=true&"
import script from "./YAH.vue?vue&type=script&lang=js&"
export * from "./YAH.vue?vue&type=script&lang=js&"
import style0 from "./YAH.vue?vue&type=style&index=0&id=1777ae8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1777ae8e",
  null
  
)

export default component.exports